<template>
  <div>
    <el-dialog
      left
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="520px"
      style="margin: 0 auto;"
      :visible.sync="isShow"
      @close="handleCancel()"
      class="investment-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="registrarSave">
        <div class="row">
          <div class="col-12">
            <div>
              Company
              <span class="required">*</span>
            </div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.portfolio_item"
              size="large"
              placeholder="Company"
            >
              <el-option
                v-for="item in portfolioAll"
                :value="item._id"
                :label="item.name"
                :key="item._id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div>
              Expense Type
              <span class="required">*</span>
            </div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.transaction_type"
              size="large"
              placeholder="Expense Type"
            >
              <el-option
                v-for="item in vals.TRANSACTION_TYPE"
                :value="item"
                :label="item"
                :key="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-6">
            <div>Payment Date</div>
            <input
              type="date"
              class="form-control team-form"
              style="width: 100%;"
              :max="moment().format('YYYY-MM-DD')"
              min="2000-01-01"
              :value="value.data.transaction_date && moment.utc(value.data.transaction_date).format('YYYY-MM-DD')"
              @input="value.data.transaction_date = moment($event.target.valueAsDate)"
              placeholder="Payment Date"
            />
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-6">
            <div>
              Round
              <span class="required">*</span>
            </div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.offering"
              size="large"
              placeholder="Round"
            >
              <el-option v-for="item in vals.STAGE_DEFINES" :value="item" :label="item" :key="item"></el-option>
            </el-select>
          </div>
        </div>-->
        <div class="row">
          <div class="col-6">
            <div>Amount</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%;"
              v-model="value.data.amount"
              placeholder="Amount"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div>Notes</div>
            <textarea
              placeholder="Notes"
              rows="5"
              cols="50"
              class="form-control"
              spellcheck="false"
              v-model="value.data.notes"
            ></textarea>
          </div>
        </div>
        <div style="padding-bottom:3px">Attachments</div>
        <div class="row m-0">
          <div class="col-4 attach-class" id="popover-target-1" style="padding-top: 6px;">
            <i class="fa fa-paperclip" aria-hidden="true"></i>
            Attach a file
            <input
              type="file"
              ref="fileBtn"
              if="fileId"
              @change="handleFile"
              class="hidden"
            />
          </div>
          <b-popover
            target="popover-target-1"
            triggers="hover"
            placement="top"
            custom-class="popover-modal-class"
          >
            <div
              class="m-2"
              style="cursor:pointer"
              @click="$refs.fileBtn.click();typeUrlCheck =false"
            >From Computer</div>
            <div class="m-2" style="cursor:pointer" @click="typeUrlCheck =!typeUrlCheck">Add Link</div>
          </b-popover>
          <div
            class="col-8 drag-drop-class"
            style="padding-top: 6px;"
            v-if="!typeUrlCheck"
            v-cloak
            @drop.prevent="addFile"
            @dragover.prevent
          >Drag and drop file to attach</div>
          <div class="col-8" style="padding:0" v-else>
            <form @submit.prevent="submitUrl">
              <input
                type="text"
                class="form-control team-form url-input-form"
                placeholder="Add a URL"
                id="myInput"
                @blur="submitUrl"
                v-model="urlValue"
                @
              />
            </form>
          </div>
        </div>
        <div class="mt-3">
          <div v-if="url.add">
            <div v-for="(item,index) in url.add" :key="index" class="fileItem my-2">
              <a :href="formatUrl(item)" target="_blank">
                <span class="attachment-name-class">{{item}}</span>
              </a>
              <i
                class="fas fa-times"
                @click="deleteURL(index,'add')"
                style="float: right;padding-top: 5px;margin-right: 18px;cursor:pointer"
              ></i>
            </div>
          </div>
          <div v-if="url.update">
            <div v-for="(item,index) in url.update" :key="index" class="fileItem my-2">
              <a :href="formatUrl(item.url)" target="_blank">
                <span class="attachment-name-class">{{item.url}}</span>
              </a>
              <i
                class="fas fa-times"
                @click="deleteURL(index,'update')"
                style="float: right;padding-top: 5px;margin-right: 18px;cursor:pointer"
              ></i>
            </div>
          </div>
          <div v-if="files.add">
            <div v-for="(item,index) in files.add" :key="index" class="d-flex fileItem my-2">
              <i
                v-if="item.type.includes('.doc') || item.name.includes('.doc') || item.name.includes('.txt')"
                class="fas fa-file-word mr-2 mt-1"
                style="color:#5190FF"
              ></i>
              <i
                v-else-if="item.type.includes('zip') || item.name.includes('.zip') || item.type.includes('rar') || item.name.includes('.rar')"
                class="far fa-file-archive mr-2 mt-1"
              ></i>
              <i v-else-if="item.type.includes('image')" class="fas fa-image mr-2"></i>
              <i
                v-else-if="item.type.includes('csv') || item.type.includes('xls') || item.name.includes('.csv') || item.name.includes('.xls')"
                class="fas fa-file-excel mr-2 mt-1"
                style="color:#F15643"
              ></i>
              <i
                v-else-if="item.type.includes('pdf') || item.type.includes('.pdf')"
                class="fas fa-file-pdf mr-2 mt-1"
              ></i>
              <span
                class="attachment-name-class"
                @click="handleDownload(item,'file')"
                style="cursor:pointer"
              >{{item.name}}</span>
              <i
                class="fas fa-times"
                @click="deleteFile(index,'add')"
                style="float: right;padding-top: 5px;margin-right: 18px;cursor:pointer"
              ></i>
            </div>
          </div>
          <div v-if="files.update">
            <div v-for="(item,index) in files.update" :key="index" class="d-flex fileItem my-2">
              <i
                v-if="item.name.includes('.doc') ||item.name.includes('.txt')  "
                style="color:#5190FF"
                class="fas fa-file-word mr-2 mt-1"
              ></i>
              <i
                v-else-if="item.name.includes('zip') || item.name.includes('.rar')"
                class="far fa-file-archive mr-2 mt-1"
              ></i>
              <i
                v-else-if="item.name.includes('.jpg') || item.name.includes('.png')"
                class="fas fa-image mr-2 mt-1"
              ></i>
              <i
                v-else-if="item.name.includes('.csv') || item.name.includes('.xls')"
                class="fas fa-file-excel mr-2 mt-1"
                style="color:#F15643"
              ></i>
              <i v-else-if="item.name.includes('.pdf')" class="fas fa-file-pdf mr-2"></i>
              <span
                class="attachment-name-class"
                @click="handleDownload(item,'s3')"
                style="cursor:pointer"
              >{{item.name}}</span>
              <i
                class="fas fa-times"
                @click="deleteFile(index,'update')"
                style="float: right;padding-top: 5px;margin-right: 18px;cursor:pointer"
              ></i>
            </div>
          </div>
        </div>
        <div class="edit-company-action-button-row pt-3" style="margin:0px">
          <button
            type="button"
            @click="handleCancel()"
            class="todo-form-cancel-button btn-outline-secondary"
          >Cancel</button>
          <!-- @click="registrarSave" -->
          <button
            type="submit"
            :disabled="disableCheck"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px;"
          >
            Save
            <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
    <a class="hidden" ref="hiddenDownloadAnchor" :href="downloadLink">Download Sample</a>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { vals, humanFileSize } from "../../../util";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import { mapGetters } from "vuex";
export default {
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
    },
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioAll"]),
    disableCheck() {
      if (
        this.value.data &&
        this.value.data.portfolio_item &&
        this.value.data.transaction_type &&
        !this.isSaving
      )
        return false;
      else return true;
    },
    moment() {
      return moment;
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
    title: {
      get() {
        return this.value.isCreate ? "Add Registrar" : "Edit Registrar";
      },
    },
  },
  watch: {
    isShow: function (val) {
      if (val) {
        this.setUploadedFiles();
      }
    },
  },
  data() {
    return {
      vals,
      isSaving: false,
      downloadLink: "",
      typeUrlCheck: false,
      urlValue: "",
      files: {
        add: [],
        update: [],
        delete: [],
      },
      url: {
        add: [],
        update: [],
        delete: [],
      },
    };
  },
  methods: {
    formatUrl(url) {
      // make sure it starts w/ http(s)
      if (url.length > 1) {
        if (!url.startsWith("https")) url = "https://" + url;
        return url;
      } else return "";
    },
    handleCancel() {
      this.value.isShow = false;
      this.isSaving = false;
      this.files = {
        add: [],
        update: [],
        delete: [],
      };
      this.url = {
        add: [],
        update: [],
        delete: [],
      };
      this.urlValue = "";
      this.typeUrlCheck = false;
    },
    submitUrl() {
      this.urlValue = this.urlValue.trim();
      if (this.urlValue.length > 0) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      this.typeUrlCheck = false;
    },
    async setUploadedFiles() {
      this.files = { add: [], delete: [], update: [] };
      let uploadedDocs = [];
      if (!this.value.isCreate && this.value.data._id) {
        uploadedDocs = await this.$store.getters["file/filesByInvestmentId"](
          this.value.data._id
        );
      }
      if (uploadedDocs.length) {
        uploadedDocs.map((item) => {
          if (item.link_type == "File") this.files.update.push(item);
          else this.url.update.push(item);
        });
      }
    },
    deleteFile(index, type) {
      if (type == "add") this.files.add.splice(index, 1);
      else {
        let data = this.files.update.splice(index, 1);
        this.files.delete.push(data[0]);
      }
    },
    deleteURL(index, type) {
      if (type == "add") this.url.add.splice(index, 1);
      else {
        let data = this.url.update.splice(index, 1);
        this.url.delete.push(data[0]);
      }
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.files.add.push(f);
      });
    },
    handleFile(e) {
      let droppedFiles = e.target.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.files.add.push(f);
      });
    },
    registrarSave() {
      this.isSaving = true;
      if (this.urlValue) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }

      if (
        !this.value.data.portfolio_item ||
        // !this.value.data.offering ||
        !this.value.data.transaction_type
      ) {
        let html = `There were validation errors with your Registrar information:\n`;
        let validationFields = "";
        if (!this.value.data.portfolio_item) {
          validationFields += "Organization,";
        }
        // if (!this.value.data.offering) {
        //   validationFields += "Offering,";
        // }
        if (!this.value.data.transaction_type) {
          validationFields += "Transaction Type,";
        }

        validationFields = validationFields.substring(
          0,
          validationFields.length - 1
        );
        html += `Missing required fields:${validationFields}`;
        alert(html);
        this.isSaving = false;
        return;
      }
      let self = this;
      if (this.value.data.notes == undefined) {
        delete this.value.data.notes;
        delete this.value.data.noteId;
      }

      if (this.value.isCreate) {
        this.$store
          .dispatch("investment/apiRegistrarSave", this.value.data)
          .then((data) => {
            self.isSaving = true;
            self.saveFiles(data.data.encrypt.success);
          })
          .catch((err) => {
            self.isSaving = false;
            self.$toaster.error("Fail to save registrar");
            //User Perform action is updated in backend post api
          });
      } else {
        this.$store
          .dispatch("investment/apiRegistrarUpdate", this.value.data)
          .then((data) => {
            self.saveFiles(data.data.encrypt.success);
          })
          .catch((err) => {
            self.isSaving = false;
            self.$toaster.error("Fail to save registrar");
          });
      }
    },
    saveFiles(savedDoc) {
      let self = this;
      let filePayload = {
        files: [],
        data: [],
      };

      _.forEach(this.files.add, (item) => {
        if (item) {
          filePayload.files.push(item);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "registrar",
            document_id: savedDoc._id,
            portfolio_item: savedDoc.portfolio_item,
            link_type: "File",
          });
        }
      });
      _.forEach(self.url.add, (item) => {
        if (item) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "registrar",
            document_id: savedDoc._id,
            portfolio_item: savedDoc.portfolio_item,
            link_type: "URL",
            url: item,
          });
        }
      });

      if (!filePayload.data.length) {
        this.updateFiles(savedDoc);
        return;
      }
      self.$store.dispatch("file/createFile", filePayload).then(
        (item) => {
          self.$store.dispatch("file/start", null, { root: true });
          if (
            item.data.encrypt.limitExceededMessage &&
            item.data.encrypt.limitExceededMessage.length > 0 &&
            item.data.encrypt.limitExceededMessage == "Storage Limit Exceeded"
          ) {
            self.$toaster.error(
              "Storage limit exceeded. Upgrade your plan to add more"
            );
          }
          self.updateFiles(savedDoc);
        },
        (error) => {
          self.$toaster.error("Fail to Save Registrar.");
          this.isSaving = false;
        }
      );
    },

    updateFiles(savedDoc) {
      let self = this;

      self.isSaving = true;

      let filePayload = {
        data: [],
      };
      let fileUpdate = [...this.files.update, ...this.url.update];
      _.forEach(fileUpdate, (item) => {
        if (item._id && self.files.delete.indexOf(item._id) == -1) {
          if (item.link_type == "File") {
            filePayload.data.push({
              _id: item._id,
              name: item.name,
              collection_name: "registrar",
              document_id: savedDoc._id,
              link_type: "URL",
            });
          } else {
            filePayload.data.push({
              _id: item._id,
              name: item.name,
              collection_name: "registrar",
              document_id: savedDoc._id,
              link_type: "URL",
              url: item.url,
            });
          }
        }
      });

      if (!filePayload.data.length) {
        this.deleteFiles(savedDoc);
        return;
      }

      self.$store.dispatch("file/updateFile", filePayload.data).then(
        (item) => {
          self.$store.dispatch("file/start", null, { root: true });
          this.deleteFiles(savedDoc);
        },
        (error) => {
          self.$toaster.error("Fail to Save Registrar.");
          this.isSaving = false;
        }
      );
    },

    deleteFiles(savedDoc) {
      let self = this;
      let fileDelete = [...this.files.delete, ...this.url.delete];
      if (!fileDelete.length) {
        if (self.$parent && self.$parent.transactionDetails) {
          let data = self.$parent.handleParseData();
          if (this.value.isCreate) {
            self.$parent.tabulator.replaceData(data);
          } else {
            self.$parent.tabulator.updateData(data);
          }
        }
        this.isSaving = false;
        this.value.isShow = false;
        this.files = { add: [], update: [], delete: [] };
        this.url = { add: [], update: [], delete: [] };
        self.$toaster.success("Saved Successfully.");
        return;
      }

      self.isSaving = true;

      let delCounter = 0;
      _.forEach(fileDelete, async (item) => {
        if (item) {
          let k = await self.$store.dispatch("file/deleteFile", item._id).then(
            (item) => {
              delCounter++;
              self.$store.dispatch("file/start", null, { root: true });
            },
            (error) => {
              self.$toaster.error("Fail to Save Registrar.");
              delCounter++;
              this.isSaving = false;
            }
          );
          if (delCounter >= fileDelete.length) {
            this.isSaving = false;
            if (self.$parent && self.$parent.transactionDetails) {
              let data = self.$parent.handleParseData();
              if (self.value.isCreate) {
                self.$parent.tabulator.replaceData(data);
              } else {
                self.$parent.tabulator.updateData(data);
              }
            }
            this.files = { add: [], update: [], delete: [] };
            this.url = { add: [], update: [], delete: [] };
            this.value.isShow = false;
            self.$toaster.success("Saved Successfully.");
          }
        }
      });
    },
    async handleDownload(item, type) {
      if (type == "s3") {
        let self = this;
        let urlData = await api
          .post(`/file/download`, {
            encrypt: {
              data: {
                s3_path: item.s3_path,
              },
            },
          })
          .catch((e) => {
            console.error("error: ", e);
          });

        if (
          urlData &&
          urlData.data &&
          urlData.data.encrypt &&
          urlData.data.encrypt.url
        ) {
          // window.open(urlData.data.encrypt.url);
          this.downloadLink = urlData.data.encrypt.url;

          setTimeout(() => {
            self.$refs.hiddenDownloadAnchor.click();
          });
        }
      }
    },
  },
};
</script>
<style >
.popover-modal-class {
  z-index: 10000;
}
.url-input-form {
  margin: 0px;
  height: 35px;
  border-bottom-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
.attachment-name-class {
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 400px;
  overflow: hidden;
  display: inline-block;
  flex-wrap: wrap;
}
</style>